<template>
  <v-card>
    <v-divider style="margin:0px"></v-divider>
    <v-card-text style="padding-top:0px">
      <v-data-table
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :total-items="pagination.totalItems"
        :items="items"
        :headers="headers"
        class="v-table-list theme--light table-default"
        
      >
        <template slot="items" scope="props">
          <tr v-bind:class="{table__selected:props.selected}">
            <td width="1%">
              
            </td>
            <!-- <td
              class="text-xs-left cut-text"
            >{{moment(props.item.creationDate,"DD/MM/YYYY HH:mm").format('DD/MM/YYYY HH:mm')}}</td> -->
            <td class="text-xs-left cut-text">{{ props.item.Agency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.DocumentType }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Date }}</td>
            <td class="text-xs-left cut-text">{{ props.item.IdFac }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Brand }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Product }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Policy }}</td>
            <td class="text-xs-left cut-text">{{ props.item.ClientName }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Premium | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Commission | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Loan | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Politics }}</td>
            <td class="text-xs-left cut-text">{{ props.item.ContractNumber }}</td>
            <td class="text-xs-left cut-text">{{ props.item.Receipt }}</td>
            <td class="text-xs-left cut-text">{{ props.item.DraftNumber }}</td>
            <td class="text-xs-left cut-text">{{ props.item.ClientCode }}</td>
          </tr>
        </template>

        <template slot="no-data">
          <div>{{$t('message.noPreliquidations')}}</div>
        </template>
        <!-- <template
          slot="pageText"
          slot-scope="props"
        >{{ props.pageStart }} - {{ props.pageStop }} {{$t('message.of')}} {{ props.itemsLength }}</template>  -->
      </v-data-table>
    </v-card-text>
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";

export default {
  props: {
       items: {
           type: Array
       }
  },
  computed: {
    ...mapGetters(["loadingCommission", "agency"])
  },
  mounted() {
    //this.$store.dispatch("getCommissionsLiquidation");
    /*     for(let i=0;i<=this.commissionsLiquidation.length; i++)
     {
       this.selectRow.push(this.commissionsLiquidation[i]);       
     } */
  },
  methods: {
    nzDate: nzDate,
    uniqueCheck(e, index) {
      for (let i = 0; i < this.selectRow.length; i++) {
        if (index != i) {
          this.selectRow[i] = false;
        }
      }
      if (!this.selectRow[index]) {
        this.selectedValue = null;
      } else {
        this.selectedValue = e;
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "creationDate") {
          let dateA = new Date(this.getDate(a[index]));
          let dateB = new Date(this.getDate(b[index]));
          /* let demoInvalidDate=new Date(a[index])
            if(demoInvalidDate=='Invalid Date'){
              var formattedA = moment(a[index]).format('D MMMM YYYY');
              //var formattedB = moment(demoInvalidDate).format('D MMMM YYYY');
              console.log(a[index],formattedA)
           
            } */
          if (!isDesc) {
            return dateA < dateB ? -1 : 1;
          } else {
            return dateB < dateA ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    getDate(d) {
      var day, month, year;

      let result = String(d).match("[0-9]{2}([-/ .])[0-9]{2}[-/ .][0-9]{4}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[0];
        month = dateSplitted[1];
        year = dateSplitted[2];
      }
      result = String(d).match("[0-9]{4}([-/ .])[0-9]{2}[-/ .][0-9]{2}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[2];
        month = dateSplitted[1];
        year = dateSplitted[0];
      }

      if (month > 12) {
        let aux = day;
        day = month;
        month = aux;
      }

      return year + "/" + month + "/" + day;
    },
    changeSort(column) {
      this.selectedValue = null;
      (this.selectRow = []), (this.additional_grouped = []);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.additional_grouped[0] = this.selectedValue;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additional_grouped[0] = this.selectedValue;
      }
      // console.log(this.pagination.sortBy)
    },
    refresh() {
      this.$store.dispatch("getCommissionsPreliquidationQuery").then(() => {
        this.selectedValue = null;
        this.additional_grouped = [];
      });
    },
    enter() {
      // if (this.searchValue != "") {
      //   this.$store.dispatch("getCommissionsLiquidation", this.searchValue);
      // } else {
      //   this.$store.dispatch("getCommissionsLiquidation");
      // }
    }
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    agency(val) {
      //this.$store.dispatch("getCommissionsLiquidation");
    }
  },
  data() {
    return {
      selectedValue: null,
      selectRow: 0,
      additional_grouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        rowsPerPageItems: [5, 10, 15, 25],
        sortBy: "creationDate"
      },
      selected: [],
      headers: [
        {
          align: "left",
          sortable: false,
          text: "",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: i18n.t("message.agency"),
          value: "type",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Tipo Doc.",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Fecha",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Factura",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Ramo",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Producto",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Póliza",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Cliente",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Prima",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Comisión",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Préstamos",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Políticas",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Contrato",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Certificado",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Nro Cuota",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: false,
          text: "Cédula",
          value: "",
          width: "1%"
        }
      ]
    };
  }
};
</script>